module.exports = __webpack_public_path__ + "static/media/rede-protecao-4.ef67ec93.jpeg";